import { makeStyles, MenuItem, Select, SelectProps, Theme } from '@material-ui/core';
import React from 'react';
import { ISupplier } from '../../../main/entities';
import { transl } from '../../../main/transl';

const useStyles = makeStyles((theme: Theme) => ({
	SupplierMultiselect: {
	},
	menuItemRoot: {
		'&.MuiListItem-root.Mui-selected': {
			backgroundColor: (theme.palette as any).special.main,
			opacity: 0.95,
		},
		'&.MuiListItem-root.Mui-selected:hover': {
			opacity: 1,
		}
	},
}));

type IMultiselectProps<E> = Omit<SelectProps, 'multiple'|'value'|'renderValue'|'onChange'> & {
	ids: Array<number>
	setIds(ids: Array<number>) : void
	repo: {
		allAsList: Array<E>,
		byId(id: number): E|undefined
	},
}

// TODO @deprecated replace by OcEdit
export const SupplierMultiselect = function SupplierMultiselect(props: IMultiselectProps<ISupplier>) {
	const classes = useStyles();
	const {ids, setIds, repo, ...rest} = props;
	return <Select className={classes.SupplierMultiselect}
		displayEmpty={true}
		{...rest}
		multiple
		value={ids}
		renderValue={(v: any) => !v.length ? transl('pleaseSelect') : v.length==1 ? repo.byId(v[0])?.name : v.length + ' ' + transl('wholesalers')}
		onChange={e => setIds(e.target.value as any)}
	>
		{repo.allAsList.map(x => <MenuItem classes={{root: classes.menuItemRoot}} value={x.id} key={x.id}>{x.name}</MenuItem>)}
	</Select>;
};
